import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';
import { createBrowserHistory } from 'history';
import Reducer from '../redux/reducers';
import initialState from './initialState';

const persistConfig = {
  key: 'root',
  storage,
  blacklist: ['refCampaign', 'dataSet', 'pilotageVolume'],
  stateReconciler: autoMergeLevel2,
};
export const history = createBrowserHistory();
const pReducer = persistReducer(persistConfig, Reducer(history));

const Enhancers = compose(applyMiddleware(thunk));

export const store = createStore(pReducer, initialState, Enhancers);
export const persistor = persistStore(store);
